(function () {
    'use strict';

    a3_cabin_reports.directive('shopInTheCloud', shopInTheCloud);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name shopInTheCloud
    * @restrict E
    * @description
    *   Implementation of shopInTheCloud panel
    * @example
    *   Usage:
    *   <shop-in-the-cloud></shop-in-the-cloud>
    * @ngInject
    */
    function shopInTheCloud (FlightOrdersFactory, $sce, $uibModal, CabinReportLocalEditFactory, SettingsMain) {
        function link(scope,  element, attributes) {
            scope.IsShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
            scope.showShopInTheCloudPanel = scope.IsShopInTheCloudEnable && scope.flight.LineStatus != 'na' && scope.flight.LineStatus != 'stored';
            scope.openOrder = openOrder;
            //get from LS the events & the types
            getOrdersForTheFlight(scope.flightId);

            function getOrdersForTheFlight(flightId) {
                scope.showPanel = null;
            
                // Retrieve the report first
                const report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
            
                if (report && report.FlightOrders && report.FlightOrders.Orders) {
                    // Use report orders as the source of truth
                    scope.flattenedOrders = {
                        FlightId: flightId,
                        Orders: report.FlightOrders.Orders.map(order => ({
                            ...order,
                            Status: order.Status || "Pending",
                            Feedback: order.Feedback || '',
                            Reason: order.Reason || '',
                            Photos: order.Photos || []
                        }))
                    };
                } else {
                    // Fallback to stored orders if no report exists
                    scope.flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId);
            
                    // Set defaults for orders if retrieved from storage
                    if (scope.flattenedOrders && scope.flattenedOrders.Orders) {
                        scope.flattenedOrders.Orders.forEach(order => {
                            order.Status = order.Status || "Pending";
                            order.Feedback = order.Feedback || '';
                            order.Reason = order.Reason || '';
                            order.Photos = order.Photos || [];
                        });
                    }
                }
            } 
            
             function openOrder(orderNumber) {
                 // Find the order object by order number
                 var order = scope.flattenedOrders.Orders.find(o => o.OrderNumber === orderNumber);

                 var modalInstance = $uibModal.open({
                     templateUrl: 'views/ShopInTheCloud/dlgOrderForm.html',
                     controller: 'OrderFormModalCtrl',
                     backdrop: 'static',
                     keyboard: false,
                     size: 'md',
                     resolve: {
                        orderDetails: function () {
                            return angular.copy(order);
                        },
                        report: function () {
                            return CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(scope.flightId); // Pass the report
                        }
                     }
                 });
 
                 modalInstance.result.then(function (updatedOrder) {
                    if (updatedOrder) {
                        // Update the specific order in flattenedOrders
                        const orderToUpdate = scope.flattenedOrders.Orders.find(o => o.OrderNumber === updatedOrder.OrderNumber);
                        if (orderToUpdate) {
                            Object.assign(orderToUpdate, updatedOrder); // Merge changes into the flattened order
                        }else {
                            scope.flattenedOrders.Orders.push(updatedOrder); // Add new order
                        }
                        FlightOrdersFactory.setFlightOrders([{ FlightId: scope.flightId, Orders: scope.flattenedOrders.Orders }]);

                        // Find and update the corresponding order in the report
                        const report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(scope.flightId);
                        if (report) {
                            if (!report.FlightOrders || !Array.isArray(report.FlightOrders.Orders)) {
                                report.FlightOrders = { Orders: [] };
                            }
            
                            const reportOrder = report.FlightOrders.Orders.find(o => o.OrderNumber === updatedOrder.OrderNumber);
                            if (reportOrder) {
                                Object.assign(reportOrder, updatedOrder); // Merge changes into the report order
                            } else {
                                // Add the order if it doesn't exist in the report
                                report.FlightOrders.Orders.push(updatedOrder);
                            }
                            // Save the updated report
                            report.updateTotals();
                            report.saveReport();                               
                        } else {
                            console.error("Report not found for flight:", scope.flightId);
                        }
                    }
                }, function () {
                    console.log("Order modal dismissed.");
                });
            }            
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/ShopInTheCloud/shopInTheCloud.tpl.html',
            scope: false,
            link: link
        }
    }

})();
